
export default {
    client: process.env.REACT_APP_AUTH0_CLIENT_ID || 'bQfV3Th805pIx0Q8nCYNd5XUiVBA7N3Z',
};
